import React from "react";

export default function (props: any) {
  const { value } = props;
  return (
    <div className={value > 0 ? "profit-pL" : "loss-pL"}>
      Expected {value > 0 ? "Profit: " : "Loss: "} {value}
    </div>
  );
}
